import {
  AfterViewInit,
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnInit,
  ViewChild
} from '@angular/core';
import KeenSlider, {KeenSliderInstance} from "keen-slider"
import {ScriptLoaderService} from "../../../services/scripts.service";

declare const window;
declare const configData;
@Component({
  selector: 'v-product-pictures',
  templateUrl: './product-pictures.component.html',
  styleUrls: [
    '../../../../../../node_modules/keen-slider/keen-slider.css',
    './product-pictures.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductPicturesComponent implements OnInit, AfterViewInit {
  @Input() pictures;
  @Input() title;
  @Input() priceInformations;
  @Input() virtualMirror;
  @Input() noPicSrc;
  @ViewChild("sliderRef") sliderRef: ElementRef<HTMLElement>;
  private virtualMirrorScriptURL = window['ACC']['productDetailsPage']?.virtualMirrorScriptURL;
  virtualMirrorScriptName = 'virtual-mirror';
  settingsMobile = null;
  slider: KeenSliderInstance = null;
  currentSlide = 0;
  gallery = -1;
  initializeVMOnStart = false

  constructor(
    private ngzone: NgZone,
    private cd: ChangeDetectorRef,
    private scriptLoaderService :ScriptLoaderService
    ) {
  }

  ngOnInit() {
    if(this.virtualMirror && this.virtualMirrorScriptURL) {
      const name = this.virtualMirrorScriptName;
      const src = this.virtualMirrorScriptURL;

      this.scriptLoaderService.addScript({name, src});
      !window.virtualMirrorPdp && this.initVirtualMirrorPdp();
      // search query params for runVM
      const runVM = new URLSearchParams(window.location.search).get('runVM');

      if (runVM) {
        this.initializeVMOnStart = true;
      }

    }
  }

  openGallery(index: number) {
    this.gallery = index;
  }

  closeGallery() {
    this.gallery = -1;
  }

  slideTo(index: number) {
    this.slider.moveToIdx(index);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.slider = new KeenSlider(this.sliderRef.nativeElement,
        {
          initial: this.currentSlide,
          slideChanged: (s) => {
            this.currentSlide = s.track.details.rel;
            this.cd.markForCheck();
          }
        });
      this.cd.markForCheck();
    });
  }

  async initVirtualMirrorPdp() {
    try {
      await this.scriptLoaderService.loadScript(this.virtualMirrorScriptName);
      window.initVirtualMirror(null);
      if (this.initializeVMOnStart) {
            this.runVirtualMirror(null)
      }
    } catch (error) {
      console.error(error);
    }
  }

  runVirtualMirror(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    const text = this.priceInformations.discountPrice ? this.priceInformations.discountPrice.formattedValue : this.priceInformations.price.formattedValue;
    const value = this.priceInformations.discountPrice ? this.priceInformations.discountPrice.value : this.priceInformations.price.value;

    configData.prices[0] = {...configData.prices[0], current: {text, value}};
    window.virtualMirrorPdp.modal.classList.add('--active');

    window.vmapp = new window.vmmv.VMWidgetApp();
    window.vmapp
      .setConfig(configData)
      .then(() => {
        window.vmapp.init()
      })
      .catch(e => {
        console.error(e)
      })
  }

  openURL(event, url) {
    event.stopPropagation();
    event.preventDefault();
    window.open(url, '_blank');
  }

  ngOnDestroy() {
    if (this.slider) this.slider.destroy()
  }
}
